import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { toStorageDate } from "../../utils/date";

const AdminAddProgram = () => {
  const [form, setForm] = useState({
    tipProgram: "",
    data: "",
    ora: "",
    locatie: "",
    cost: "",
  });

  const [popup, setPopup] = useState({
    show: false,
    message: "",
    success: true,
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const showPopup = (message, success = true) => {
    setPopup({ show: true, message, success });
    setTimeout(
      () => setPopup({ show: false, message: "", success: true }),
      3000
    );
  };

  const handleAddProgram = async () => {
    try {
      const { tipProgram, data, ora, locatie, cost } = form;
      const dataValue = toStorageDate(data);
      if (!tipProgram || !dataValue || !ora || !locatie || !cost) {
        showPopup("Completează toate câmpurile!", false);
        return;
      }

      await addDoc(collection(db, "stabilire_program"), {
        ...form,
        data: dataValue,
        createdAt: serverTimestamp(),
      });

      showPopup("Program adăugat cu succes!", true);
      setForm({ tipProgram: "", data: "", ora: "", locatie: "", cost: "" });
    } catch (error) {
      console.error("Eroare Firebase:", error);
      showPopup("Eroare la adăugare program!", false);
    }
  };

  return (
    <div className="admin-card admin-program admin-card-compact relative">
      {popup.show && (
        <div
          className={`absolute inset-0 flex items-center justify-center rounded-xl text-white font-semibold text-sm ${
            popup.success ? "bg-green-600/90" : "bg-red-600/90"
          } transition-all duration-500`}
        >
          {popup.message}
        </div>
      )}

      <h3 className="admin-card-header">Adaugă program</h3>
      <div className="admin-card-grid-2">
        <div className="admin-field">
          <label className="admin-label">Tip program</label>
          <select
            name="tipProgram"
            className="admin-select"
            value={form.tipProgram}
            onChange={handleChange}
          >
            <option value="">Selectează...</option>
            <option value="MAI">MAI</option>
            <option value="MAPN">MAPN</option>
            <option value="ISU">ISU</option>
            <option value="ANP">ANP</option>
          </select>
        </div>

        <div className="admin-field">
          <label className="admin-label">Ora</label>
          <input
            type="time"
            className="admin-input"
            name="ora"
            value={form.ora}
            onChange={handleChange}
          />
        </div>

        <div className="admin-field">
          <label className="admin-label">Data</label>
          <input
            type="date"
            className="admin-input"
            name="data"
            value={form.data}
            onChange={handleChange}
          />
        </div>

        <div className="admin-field">
          <label className="admin-label">Cost</label>
          <input
            className="admin-input"
            name="cost"
            value={form.cost}
            onChange={handleChange}
            placeholder="100 lei"
          />
        </div>

        <div className="admin-field">
          <label className="admin-label">Locație</label>
          <input
            className="admin-input"
            name="locatie"
            value={form.locatie}
            onChange={handleChange}
            placeholder="Ex: FitZone Constanța"
          />
        </div>
      </div>

      <button className="admin-button mt-3" onClick={handleAddProgram}>
        Adaugă program
      </button>
    </div>
  );
};

export default AdminAddProgram;
